(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beroc-clube-embaixadores"] && !Shopify.designMode) return;
  try {
    
(function () {
  var KLAVIYO_REVISION = '2024-10-15';
  var TOTAL_STEPS = 3;
  var LABELS = {
    1: 'Passo 1 de 3 · quem é você',
    2: 'Passo 2 de 3 · sua vida',
    3: 'Passo 3 de 3 · sua audiência e o acordo'
  };

  function init(root) {
    if (!root || root.dataset.bcReady === '1') return;
    root.dataset.bcReady = '1';

    var form = root.querySelector('[data-beroc-form]');
    var done = root.querySelector('[data-done]');
    if (!form || !done) return;

    var steps = form.querySelectorAll('[data-step]');
    var bar = form.querySelector('[data-progress-bar]');
    var stepLabel = form.querySelector('[data-step-label]');
    var submitBtn = form.querySelector('[data-submit]');
    var formError = form.querySelector('[data-form-error]');
    var viewsField = form.querySelector('[data-views]');
    var phone = form.querySelector('[name="whatsapp"]');
    var companyId = root.dataset.companyId;
    var listId = root.dataset.listId;

    function stepEl(n) { return form.querySelector('[data-step="' + n + '"]'); }

    function showStep(n) {
      steps.forEach(function (s) { s.hidden = s.dataset.step !== String(n); });
      if (bar) bar.style.width = Math.round((n / TOTAL_STEPS) * 100) + '%';
      if (stepLabel) stepLabel.textContent = LABELS[n] || '';
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function setError(el, msg) {
      var field = el.closest('.beroc-clube__field') || el.closest('.beroc-clube__consent');
      var slot = field ? field.querySelector('[data-error]') : null;
      if (!slot) return;
      slot.textContent = msg || '';
      slot.classList.toggle('is-visible', !!msg);
    }

    function validate(el) {
      var ok = true;
      var seen = {};
      el.querySelectorAll('[required]').forEach(function (f) {
        if (f.type === 'radio') {
          if (seen[f.name]) return;
          seen[f.name] = true;
          if (!el.querySelector('[name="' + f.name + '"]:checked')) { setError(f, 'Escolha uma opção.'); ok = false; }
          else setError(f, '');
          return;
        }
        if (f.type === 'checkbox') {
          if (!f.checked) { setError(f, 'Precisamos do seu aceite para continuar.'); ok = false; }
          else setError(f, '');
          return;
        }
        var value = (f.value || '').trim();
        if (!value) { setError(f, 'Preenche esse campo.'); ok = false; return; }
        if (f.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) { setError(f, 'Confere o e-mail.'); ok = false; return; }
        if (f.type === 'tel' && value.replace(/\D/g, '').length < 10) { setError(f, 'Confere o número com DDD.'); ok = false; return; }
        if (f.type === 'url' && !/^https?:\/\/.+\..+/.test(value)) { setError(f, 'Cole o link completo, começando com https://'); ok = false; return; }
        setError(f, '');
      });
      // a rotina precisa de pelo menos uma marcada
      var rotina = el.querySelectorAll('[name="rotina"]');
      if (rotina.length && !el.querySelector('[name="rotina"]:checked')) {
        setError(rotina[0], 'Marque pelo menos uma.');
        ok = false;
      } else if (rotina.length) {
        setError(rotina[0], '');
      }
      if (!ok) {
        var first = el.querySelector('.beroc-clube__error.is-visible');
        if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return ok;
    }

    if (phone) {
      phone.addEventListener('input', function () {
        var d = phone.value.replace(/\D/g, '').slice(0, 11);
        var out = d;
        if (d.length > 2) out = '(' + d.slice(0, 2) + ') ' + d.slice(2);
        if (d.length > 7) {
          var split = d.length > 10 ? 7 : 6;
          out = '(' + d.slice(0, 2) + ') ' + d.slice(2, split) + '-' + d.slice(split);
        }
        phone.value = out;
      });
    }

    var followers = form.querySelector('[data-followers]');
    if (followers && viewsField) {
      followers.addEventListener('change', function (e) {
        var big = ['10 mil a 50 mil', '50 mil a 100 mil', 'Mais de 100 mil'].indexOf(e.target.value) > -1;
        viewsField.hidden = !big;
      });
    }

    // no máximo duas motivações
    var interesses = form.querySelectorAll('[name="interesse"]');
    interesses.forEach(function (c) {
      c.addEventListener('change', function () {
        var marcados = form.querySelectorAll('[name="interesse"]:checked');
        if (marcados.length > 2) c.checked = false;
      });
    });

    form.querySelectorAll('[data-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var atual = btn.closest('[data-step]');
        if (validate(atual)) showStep(Number(btn.dataset.next));
      });
    });
    form.querySelectorAll('[data-back]').forEach(function (btn) {
      btn.addEventListener('click', function () { showStep(Number(btn.dataset.back)); });
    });

    function payload() {
      var fd = new FormData(form);
      function one(k) { return (fd.get(k) || '').toString().trim(); }
      function many(k) { return fd.getAll(k).join(', '); }
      var handle = one('instagram').replace(/^@+/, '').replace(/\s/g, '');
      var digits = one('whatsapp').replace(/\D/g, '');
      return {
        nome: one('nome'),
        handle: handle,
        instagramUrl: handle ? 'https://instagram.com/' + handle : '',
        outraRede: one('outra_rede').replace(/^@+/, ''),
        email: one('email').toLowerCase(),
        phone: digits.length >= 10 ? '+55' + digits : '',
        cidade: one('cidade'),
        rotina: many('rotina'),
        profissao: one('profissao'),
        audienciaEspera: one('audiencia_espera'),
        porqueBeroc: one('porque_beroc'),
        cliente: one('cliente'),
        seguidores: one('seguidores'),
        publico: one('publico'),
        views: one('views'),
        link: one('link'),
        interesse: many('interesse'),
        whitelisting: one('whitelisting')
      };
    }

    function properties(d) {
      return {
        'Clube Beroc': true,
        'Instagram Handle': d.handle,
        'Instagram URL': d.instagramUrl,
        'Outra Rede': d.outraRede,
        'Cidade': d.cidade,
        'Profissao': d.profissao,
        'Rotina com a Beroc': d.rotina,
        'O que a Audiencia Espera': d.audienciaEspera,
        'Por que a Beroc': d.porqueBeroc,
        'Relacao com a Marca': d.cliente,
        'Faixa de Seguidores': d.seguidores,
        'Publico Predominante': d.publico,
        'Views Medias Story': d.views ? Number(d.views) : null,
        'Link de Conteudo': d.link,
        'Motivacao': d.interesse,
        'Autoriza Whitelisting': d.whitelisting,
        'Origem da Inscricao': root.dataset.origem || 'pagina-embaixadores',
        'Data de Inscricao': new Date().toISOString(),
        'Status Clube': 'Inscrito',
        'Aceite Uso de Imagem': true
      };
    }

    function post(path, body) {
      return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: KLAVIYO_REVISION },
        body: JSON.stringify(body)
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!validate(stepEl(3))) return;
      if (formError) formError.hidden = true;
      submitBtn.disabled = true;
      submitBtn.textContent = 'ENVIANDO...';

      var d = payload();
      var props = properties(d);
      var profileAttrs = {
        email: d.email,
        first_name: d.nome.split(' ')[0],
        last_name: d.nome.split(' ').slice(1).join(' '),
        properties: props
      };
      if (d.phone) profileAttrs.phone_number = d.phone;

      var calls = [
        post('profiles', { data: { type: 'profile', attributes: profileAttrs } }),
        post('subscriptions', {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Clube Beroc - pagina de embaixadores',
              profile: { data: { type: 'profile', attributes: { email: d.email, properties: props } } }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        }),
        post('events', {
          data: {
            type: 'event',
            attributes: {
              properties: props,
              metric: { data: { type: 'metric', attributes: { name: 'Inscricao Clube Beroc' } } },
              profile: { data: { type: 'profile', attributes: profileAttrs } }
            }
          }
        })
      ];

      Promise.allSettled(calls).then(function (results) {
        var anyOk = results.some(function (r) { return r.status === 'fulfilled' && r.value && r.value.ok; });
        if (!anyOk) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'TENTAR DE NOVO';
          if (formError) {
            formError.hidden = false;
            formError.textContent = 'Não consegui enviar agora. Tenta de novo em alguns segundos ou chama a gente no direct @beroc.';
          }
          return;
        }
        form.hidden = true;
        done.hidden = false;
        var cupom = root.dataset.cupom;
        var box = done.querySelector('[data-coupon]');
        if (cupom && box) {
          box.hidden = false;
          done.querySelector('[data-coupon-code]').textContent = cupom;
        }
        done.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
          window.Shopify.analytics.publish('clube_beroc_inscricao', { origem: root.dataset.origem || '' });
        }
      });
    });

    var copyBtn = done.querySelector('[data-copy]');
    if (copyBtn) copyBtn.addEventListener('click', function () {
      var code = done.querySelector('[data-coupon-code]').textContent;
      if (navigator.clipboard) navigator.clipboard.writeText(code);
      copyBtn.textContent = 'copiado';
      setTimeout(function () { copyBtn.textContent = 'copiar'; }, 2000);
    });
  }

  function boot() { document.querySelectorAll('.beroc-clube').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beroc-plinko-popup"]) return;
  try {
    
(function () {
  var root = document.querySelector('[data-bplinko]');
  if (!root) return;

  var STORAGE_KEY = 'beroc:plinko';
  var PEG_ROWS = 6;
  var REVISION = '2024-10-15';
  var EASE = 'cubic-bezier(.45,.05,.55,.95)';

  var prizes = [];
  try {
    prizes = JSON.parse(root.querySelector('[data-bplinko-prizes]').textContent);
  } catch (e) {
    return;
  }
  if (!prizes.length) return;

  var cfg = {
    delay: parseInt(root.dataset.delay, 10) || 0,
    exitIntent: root.dataset.exitIntent === 'true',
    frequencyDays: parseInt(root.dataset.frequencyDays, 10) || 0,
    onlyIndex: root.dataset.onlyIndex === 'true',
    pageType: root.dataset.pageType,
    isCustomer: root.dataset.isCustomer === 'true',
    hideForCustomers: root.dataset.hideForCustomers === 'true',
    key: root.dataset.klaviyoKey,
    listEmail: root.dataset.listEmail,
    listPhone: root.dataset.listPhone,
    phoneStep: root.dataset.phoneStep === 'true'
  };

  var board = root.querySelector('[data-bplinko-board]');
  var pegsEl = root.querySelector('[data-bplinko-pegs]');
  var slotsEl = root.querySelector('[data-bplinko-slots]');
  var ball = root.querySelector('[data-bplinko-ball]');
  var playBtn = root.querySelector('[data-bplinko-play]');

  var state = { prize: null, email: '', opened: false, played: false, step: 'game' };

  /* ---------- helpers ---------- */

  function read() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}; } catch (e) { return {}; }
  }

  function write(patch) {
    var next = Object.assign(read(), patch);
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(next)); } catch (e) {}
  }

  function shouldShow() {
    if (cfg.hideForCustomers && cfg.isCustomer) return false;
    if (cfg.onlyIndex && cfg.pageType !== 'index') return false;

    var saved = read();
    if (saved.completed) return false;
    if (saved.dismissedAt && cfg.frequencyDays > 0) {
      var elapsed = Date.now() - saved.dismissedAt;
      if (elapsed < cfg.frequencyDays * 86400000) return false;
    }
    return true;
  }

  function step(name) {
    state.step = name;
    root.querySelectorAll('[data-bplinko-step]').forEach(function (el) {
      el.hidden = el.dataset.bplinkoStep !== name;
    });
  }

  /* ---------- medicao ---------- */

  // O funil mora no GA4. A loja ja carrega gtag, entao `bplinko_viewed` entrega
  // o denominador que o painel de Sign-up Forms do Klaviyo dava com "Viewed
  // Form" — sem ele so da pra contar cadastro, sem taxa. O dataLayer vai junto
  // pra quem preferir montar a tag no GTM.
  function rastrear(nome, extra) {
    var props = { plinko_premio: state.prize ? state.prize.label : '', plinko_etapa: state.step };
    if (extra) {
      for (var k in extra) {
        if (Object.prototype.hasOwnProperty.call(extra, k)) props[k] = extra[k];
      }
    }

    try {
      if (typeof window.gtag === 'function') window.gtag('event', nome, props);
    } catch (e) {}

    try {
      window.dataLayer = window.dataLayer || [];
      var dl = { event: nome };
      for (var j in props) {
        if (Object.prototype.hasOwnProperty.call(props, j)) dl[j] = props[j];
      }
      window.dataLayer.push(dl);
    } catch (e) {}
  }

  // No Klaviyo so entram os eventos depois da identificacao: `track` de visitante
  // anonimo e descartado, e contar "visualizou" so de quem ja e conhecido daria
  // uma taxa inflada. Estes servem pra montar flow e segmento.
  function rastrearKlaviyo(nome, extra) {
    try {
      if (window.klaviyo && typeof window.klaviyo.push === 'function') {
        window.klaviyo.push(['track', nome, extra || {}]);
      }
    } catch (e) {}
  }

  function pickPrize() {
    // Peso 0 = enfeite: aparece no tabuleiro mas nunca e sorteado. E assim que
    // se trava o resultado sem tirar os slots perdedores da vista.
    var pool = [];
    prizes.forEach(function (p, i) {
      var w = typeof p.weight === 'number' ? p.weight : 1;
      if (w > 0) pool.push({ index: i, weight: w });
    });
    if (!pool.length) return 0;

    var total = pool.reduce(function (sum, p) { return sum + p.weight; }, 0);
    var roll = Math.random() * total;
    for (var i = 0; i < pool.length; i++) {
      roll -= pool[i].weight;
      if (roll < 0) return pool[i].index;
    }
    return pool[pool.length - 1].index;
  }

  /* ---------- tabuleiro ---------- */

  function buildBoard() {
    var maxPegs = PEG_ROWS + 1;
    var spacing = 100 / maxPegs;
    var html = '';

    for (var r = 0; r < PEG_ROWS; r++) {
      var count = r + 2;
      var y = ((r + 0.6) / (PEG_ROWS + 0.9)) * 100;
      for (var i = 0; i < count; i++) {
        var x = 50 + (i - (count - 1) / 2) * spacing;
        html += '<span class="bplinko__peg" style="left:' + x.toFixed(2) + '%;top:' + y.toFixed(2) + '%"></span>';
      }
    }
    pegsEl.innerHTML = html;

    slotsEl.innerHTML = prizes.map(function (p) {
      return '<span class="bplinko__slot">' + p.label + '</span>';
    }).join('');
  }

  function slotCenterPercent(index) {
    return ((index + 0.5) / prizes.length) * 100;
  }

  function drop(index) {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var targetX = slotCenterPercent(index);
    var slotTop = slotsEl.offsetTop;
    var height = board.clientHeight;
    var startX = 50;

    var hops = [];
    for (var r = 0; r < PEG_ROWS; r++) {
      var t = (r + 1) / PEG_ROWS;
      var ideal = startX + (targetX - startX) * t;
      var jitter = (Math.random() - 0.5) * 14 * (1 - t);
      hops.push({
        x: ideal + jitter,
        y: ((r + 0.6) / (PEG_ROWS + 0.9)) * height
      });
    }
    hops.push({ x: targetX, y: slotTop + slotsEl.clientHeight / 2 });

    ball.classList.add('is-live');

    if (reduced) {
      var finalDx = (targetX - 50) / 100 * board.clientWidth;
      ball.style.transform = 'translate(' + finalDx + 'px,' + hops[hops.length - 1].y + 'px)';
      return new Promise(function (resolve) { setTimeout(resolve, 200); });
    }

    // Uma animacao unica com todos os keyframes, em vez de encadear uma
    // animacao por fileira. Encadeando, o navegador remove automaticamente as
    // animacoes `fill: forwards` que se substituem e a corrente de promises
    // morre no meio da queda.
    var HOP_MS = 190;
    var duration = hops.length * HOP_MS;
    var frames = [{ transform: 'translate(0px,0px)', offset: 0, easing: EASE }];

    hops.forEach(function (hop, i) {
      var dx = (hop.x - 50) / 100 * board.clientWidth;
      frames.push({
        transform: 'translate(' + dx + 'px,' + hop.y + 'px)',
        offset: (i + 1) / hops.length,
        easing: EASE
      });
      // O pino acende no instante em que a bola passa por ele.
      setTimeout(function () { highlightPeg(hop.x, hop.y); }, i * HOP_MS);
    });

    var anim = ball.animate(frames, { duration: duration, fill: 'forwards' });

    // Nao dependa de `anim.finished`: em varios motores (WebView do Instagram
    // e do TikTok, de onde vem boa parte do trafego) a promise simplesmente
    // nunca resolve, mesmo com a animacao terminando. O evento `finish` cobre
    // o caso normal e o timeout garante que o funil nunca trave na tela 1.
    return new Promise(function (resolve) {
      var settled = false;
      function done() {
        if (settled) return;
        settled = true;
        resolve();
      }
      anim.onfinish = done;
      setTimeout(done, duration + 150);
    });
  }

  function highlightPeg(xPercent, yPx) {
    var height = board.clientHeight || 1;
    var yPercent = (yPx / height) * 100;
    var best = null;
    var bestDist = Infinity;

    pegsEl.querySelectorAll('.bplinko__peg').forEach(function (peg) {
      var px = parseFloat(peg.style.left);
      var py = parseFloat(peg.style.top);
      var dist = Math.pow(px - xPercent, 2) + Math.pow(py - yPercent, 2);
      if (dist < bestDist) { bestDist = dist; best = peg; }
    });

    if (best && bestDist < 90) {
      best.classList.add('is-hit');
      setTimeout(function () { best.classList.remove('is-hit'); }, 220);
    }
  }

  /* ---------- Klaviyo ---------- */

  function subscribe(listId, attributes) {
    if (!cfg.key || !listId) return Promise.resolve(false);

    // O endpoint /client/subscriptions/ NAO aceita `subscriptions` dentro do
    // perfil — devolve 400 e o cadastro se perde. O proprio endpoint ja da o
    // consentimento conforme o opt-in configurado na lista.
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: attributes } },
          custom_source: 'Pop-up Plinko'
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };

    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.key), {
      method: 'POST',
      headers: { 'content-type': 'application/json', revision: REVISION },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) {
        return res.text().then(function (body) {
          console.warn('[bplinko] Klaviyo recusou a inscrição (' + res.status + '):', body);
          return false;
        });
      }
      return true;
    }).catch(function (err) {
      console.warn('[bplinko] Falha de rede ao falar com o Klaviyo:', err);
      return false;
    });
  }

  function prizeProps() {
    return {
      plinko_premio: state.prize ? state.prize.label : '',
      plinko_cupom: state.prize ? state.prize.code : ''
    };
  }

  /* ---------- formulários ---------- */

  function bindForm(name, handler) {
    var form = root.querySelector('[data-bplinko-form="' + name + '"]');
    if (!form) return;

    var error = form.querySelector('[data-bplinko-error]');
    var button = form.querySelector('button[type="submit"]');
    var label = button.querySelector('[data-bplinko-btn-label]');
    var original = label.textContent;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      error.hidden = true;

      var input = form.querySelector('input');
      var value = input.value.trim();
      var invalid = handler.validate(value);

      if (invalid) {
        error.textContent = invalid;
        error.hidden = false;
        input.focus();
        return;
      }

      function falhou() {
        error.textContent = 'Não conseguimos concluir agora. Tente de novo.';
        error.hidden = false;
        input.focus();
      }

      button.disabled = true;
      label.textContent = 'Enviando…';

      handler.submit(value, falhou).then(function () {
        button.disabled = false;
        label.textContent = original;
      });
    });
  }

  bindForm('email', {
    validate: function (value) {
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(value)) return 'Digite um e-mail válido.';
      return null;
    },
    submit: function (value, falhou) {
      var attrs = { email: value, properties: prizeProps() };

      return subscribe(cfg.listEmail, attrs).then(function (ok) {
        // Capturar o contato E o motivo do pop-up existir. Se o Klaviyo
        // recusar, nao avanca calado — avisa e deixa tentar de novo.
        if (!ok) {
          rastrear('bplinko_erro', { plinko_etapa: 'email' });
          return falhou();
        }
        state.email = value;
        write({ email: value });
        rastrear('bplinko_email');
        rastrearKlaviyo('Plinko - E-mail', { premio: state.prize ? state.prize.label : '' });
        if (cfg.phoneStep) {
          step('phone');
        } else {
          finish();
        }
      });
    }
  });

  bindForm('phone', {
    validate: function (value) {
      var digits = value.replace(/\D/g, '');
      if (digits.length < 10 || digits.length > 11) return 'Digite o DDD + número.';
      return null;
    },
    submit: function (value, falhou) {
      var digits = value.replace(/\D/g, '');
      var attrs = {
        phone_number: '+55' + digits,
        properties: prizeProps()
      };
      // Mesmo perfil do passo anterior: manda o e-mail junto pra o Klaviyo
      // casar os dois em vez de criar um perfil solto so com telefone.
      if (state.email) attrs.email = state.email;

      return subscribe(cfg.listPhone, attrs).then(function (ok) {
        if (!ok) {
          rastrear('bplinko_erro', { plinko_etapa: 'whatsapp' });
          return falhou();
        }
        rastrear('bplinko_whatsapp');
        rastrearKlaviyo('Plinko - WhatsApp', { premio: state.prize ? state.prize.label : '' });
        finish();
      });
    }
  });

  /* ---------- máscara de telefone ---------- */

  var phoneInput = root.querySelector('.bplinko__input--phone');
  if (phoneInput) {
    phoneInput.addEventListener('input', function () {
      var d = phoneInput.value.replace(/\D/g, '').slice(0, 11);
      if (d.length > 6) {
        phoneInput.value = '(' + d.slice(0, 2) + ') ' + d.slice(2, d.length - 4) + '-' + d.slice(-4);
      } else if (d.length > 2) {
        phoneInput.value = '(' + d.slice(0, 2) + ') ' + d.slice(2);
      } else {
        phoneInput.value = d;
      }
    });
  }

  /* ---------- fluxo ---------- */

  function finish() {
    var prize = state.prize || prizes[0];
    root.querySelector('[data-bplinko-reward-title]').textContent = prize.reward_title || prize.label;
    root.querySelector('[data-bplinko-reward-sub]').textContent = prize.reward_subtitle || '';

    var codeWrap = root.querySelector('[data-bplinko-code]');
    if (prize.code) {
      root.querySelector('[data-bplinko-code-value]').textContent = prize.code;
      codeWrap.hidden = false;
    } else {
      codeWrap.hidden = true;
    }

    write({ completed: true, completedAt: Date.now() });
    step('done');
    rastrear('bplinko_concluido');
    rastrearKlaviyo('Plinko - Concluido', { premio: prize.reward_title || prize.label });
  }

  function play() {
    if (state.played) return;
    state.played = true;
    playBtn.disabled = true;

    var index = pickPrize();
    state.prize = prizes[index];
    rastrear('bplinko_jogou');

    drop(index).then(function () {
      slotsEl.children[index].classList.add('is-won');
      root.querySelector('[data-bplinko-prize-label]').textContent = state.prize.label;
      setTimeout(function () { step('email'); }, 750);
    });
  }

  function open() {
    if (state.opened || !shouldShow()) return;

    // Aba em segundo plano (trocar de app no celular e o caso comum): adiar.
    // Abrir aqui contaria um `bplinko_viewed` que ninguem viu, inflando o
    // denominador do funil — e o requestAnimationFrame nem roda com a aba
    // oculta, entao o pop-up ficaria com opacidade 0, presente e invisivel.
    if (document.visibilityState === 'hidden') {
      if (state.aguardandoVisibilidade) return;
      state.aguardandoVisibilidade = true;
      document.addEventListener('visibilitychange', function aoVoltar() {
        if (document.visibilityState === 'hidden') return;
        document.removeEventListener('visibilitychange', aoVoltar);
        state.aguardandoVisibilidade = false;
        open();
      });
      return;
    }

    state.opened = true;
    root.hidden = false;
    buildBoard();
    // Reflow forcado no lugar de requestAnimationFrame: a transicao pega do
    // mesmo jeito e nao depende do frame ser agendado.
    void root.offsetWidth;
    root.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    // Denominador do funil. Sem ele so existe volume de cadastro, sem taxa.
    rastrear('bplinko_viewed');
  }

  function close() {
    root.classList.remove('is-open');
    document.body.style.overflow = '';
    if (!read().completed) {
      write({ dismissedAt: Date.now() });
      // `plinko_etapa` diz onde a pessoa desistiu — o dado que mostra o que corrigir.
      rastrear('bplinko_fechado');
    }
    setTimeout(function () { root.hidden = true; }, 350);
  }

  /* ---------- listeners ---------- */

  playBtn.addEventListener('click', play);

  root.querySelectorAll('[data-bplinko-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });

  var copy = root.querySelector('[data-bplinko-copy]');
  if (copy) {
    copy.addEventListener('click', function () {
      var code = root.querySelector('[data-bplinko-code-value]').textContent;
      navigator.clipboard.writeText(code).then(function () {
        var was = copy.textContent;
        copy.textContent = 'Copiado!';
        setTimeout(function () { copy.textContent = was; }, 1800);
      });
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !root.hidden) close();
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:select', open);
    open();
    return;
  }

  if (cfg.delay >= 0) setTimeout(open, cfg.delay * 1000);

  if (cfg.exitIntent) {
    document.addEventListener('mouseout', function (event) {
      if (!event.relatedTarget && event.clientY <= 0) open();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beroc-rastreio"]) return;
  try {
    
(() => {
  const SAL = 'beroc';

  async function sha(texto) {
    const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(texto));
    return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, '0')).join('').slice(0, 32);
  }

  function iniciar(form) {
    if (form.dataset.pronto) return;
    form.dataset.pronto = '1';
    let modo = 'pedido';
    const erro = form.querySelector('[data-erro]');
    const botao = form.querySelector('[type="submit"]');

    form.querySelectorAll('[data-modo]').forEach((aba) => {
      aba.addEventListener('click', () => {
        modo = aba.dataset.modo;
        form.querySelectorAll('[data-modo]').forEach((a) => {
          a.classList.toggle('is-ativa', a === aba);
          a.setAttribute('aria-selected', a === aba);
        });
        form.querySelectorAll('[data-campos]').forEach((c) => { c.hidden = c.dataset.campos !== modo; });
        erro.hidden = true;
      });
    });

    function falhar(msg) {
      erro.textContent = msg;
      erro.hidden = false;
      botao.disabled = false;
    }

    function trocarModo(novo) {
      const aba = form.querySelector(`[data-modo="${novo}"]`);
      if (aba) aba.click();
    }

    // Links antigos (ParcelWILL, e-mail de confirmação) chegam com parâmetros:
    // ?nums=CÓDIGO  ·  ?order=1234&email=...  ·  ?codigo= / ?pedido=
    // Preenche e busca sozinho; se faltar o e-mail, deixa o número pronto.
    function lerLink() {
      if (!/^\/pages\/rastreio-beroc/.test(window.location.pathname)) return;
      const p = new URLSearchParams(window.location.search);
      const codigo = (p.get('nums') || p.get('codigo') || p.get('tracking') || p.get('tracking_number') || '').split(',')[0].trim();
      const pedido = (p.get('order') || p.get('pedido') || p.get('order_number') || '').replace(/\D/g, '');
      const email = (p.get('email') || '').trim();
      if (codigo) {
        trocarModo('codigo');
        form.codigo.value = codigo;
        form.requestSubmit();
      } else if (pedido) {
        form.pedido.value = pedido;
        if (email) { form.email.value = email; form.requestSubmit(); } else { form.email.focus(); }
      }
    }

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      erro.hidden = true;
      let url;
      if (modo === 'pedido') {
        const numero = (form.pedido.value || '').replace(/\D/g, '');
        const email = (form.email.value || '').trim().toLowerCase();
        if (!numero || !email.includes('@')) return falhar('Preencha o número do pedido e o e-mail usado na compra.');
        url = '/pages/rastreio-pedido/' + (await sha(`${SAL}|${numero}|${email}`));
      } else {
        const codigo = (form.codigo.value || '').replace(/\s/g, '').toUpperCase();
        if (codigo.length < 8) return falhar('Confira o código de rastreio: ele costuma ter mais de 10 caracteres.');
        url = '/pages/rastreio-codigo/' + (await sha(`${SAL}|${codigo}`));
      }
      botao.disabled = true;
      try {
        const r = await fetch(url, { method: 'HEAD' });
        if (r.ok) { window.location.href = url; return; }
        falhar(modo === 'pedido'
          ? 'Não achamos esse pedido com esse e-mail. Confira os dois (o número está no e-mail de confirmação) ou tente pelo código de rastreio.'
          : 'Não achamos esse código. Pedidos recém-postados podem levar algumas horas para aparecer aqui.');
      } catch (err) {
        falhar('Sem conexão agora. Tente de novo em instantes.');
      }
    });

    lerLink();
  }

  const rodar = () => document.querySelectorAll('[data-rastreio-busca]').forEach(iniciar);
  rodar();
  document.addEventListener('shopify:section:load', rodar);
})();

  } catch(e) { console.error(e); }
})();
})();
